<div class="ple-notification-icon">
    <mat-icon [ngClass]="badgeClass" [matMenuTriggerFor]="onDemandData.length > 0 ? notificationMenu : ''" [matBadge]="onDemandData.length > 0 ? onDemandData.length : null" matBadgeColor="warn"  (menuOpened)="notificationsOpened()" (menuClosed)="notificationsClosed()">notifications_none</mat-icon>
</div>

<mat-menu class="navigation-menu" #notificationMenu="matMenu" yPosition="below">
<div class="ple-notification-conatiner" (click) = "$event.stopPropagation()">
    <div style="display: flex">
        <label class="ple-notification-label">Notifications</label>
        <mat-icon (click)="closeNotifications()" class="ple-sync-close-header">close</mat-icon>
    </div>
    <hr class="margin-t10"/>
    <div class="ple-sync-container">
        <label class="ple-sync-title">Syncing data {{syncRequestsInProgress.length}}/{{onDemandData.length}}</label>
        <div>
            <ng-container  *ngFor="let demandData of onDemandData; index as i">
                <div class="ple-sync-item">
                        <div class="ple-sync-status-icons">
                            <mat-icon matTooltip="Completed" class="ple-checked" *ngIf="demandData.syncStatus === 'Completed'" mat>check_circle_outline</mat-icon>
                            <mat-icon matTooltip="Error" class="ple-sync-error" *ngIf="demandData.syncStatus === 'Error'">error_outline</mat-icon>
                            <mat-icon matTooltip="No Data" class="ple-sync-warning" *ngIf="demandData.syncStatus === 'NoData'">error_outline</mat-icon>
                        </div>
                        <span class="ple-sync-device-name">{{demandData.deviceName}}</span>
                        <span class="ple-sync-time">{{demandData.formattedDate}} {{demandData.formattedTime}}</span>
                        <div class="ple-sync-status-icons">
                            <mat-icon *ngIf="demandData.syncStatus === 'Completed'" (click)="syncDownload(demandData)" class="ple-sync-download">save_alt</mat-icon>
                            <mat-icon (click)="openProceedModal(demandData.id)" *ngIf="demandData.syncStatus === 'InProgress'" class="ple-sync-close-item">close</mat-icon>
                            <mat-icon *ngIf="demandData.syncStatus !== 'InProgress' && demandData.syncStatus !== 'Completed'" class="ple-sync-close-item">close</mat-icon>
                        </div>
                </div>
                <div  *ngIf="demandData.syncStatus === 'InProgress'" class="ple-sync-margin">
                    <p>Syncing data.....</p>
                    <mat-progress-bar class="ple-sync-progress" mode="indeterminate"></mat-progress-bar>
                </div>
                <hr class="margin-t10"/>
            </ng-container>
        </div>
        
    </div>
</div>
</mat-menu>
<div class="dialog-container">
    <ng-template #showProceedModal>
        <div class="confirm-title">
            <h4 mat-dialog-title class="cancel-sync-title">{{CANCEL_SYNC_TITLE}}</h4>
        </div>
        <hr class="control-command-error-header">
        <mat-dialog-content class="mat-typography">
            <p>{{CONSTANTMESSAGE.CANCEL_SYNC}}</p>
        </mat-dialog-content>
        <mat-dialog-actions align="end">
            <button mat-button mat-dialog-close>Cancel</button>
            <button mat-flat-button mat-dialog-close class="mat-button-primary-sm" (click)="cancelDemandSync()">Confirm</button>
        </mat-dialog-actions>
    </ng-template>
</div>